/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForBillingOntologyBudgetSyncAdhoc extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForBillingOntologyBudgetSyncAdhoc");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForBillingOntologyBudgetSyncAdhoc.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForBillingOntologyBudgetSyncAdhoc>): BackgroundJobPayloadForBillingOntologyBudgetSyncAdhoc {
        let obj = Object.assign(new BackgroundJobPayloadForBillingOntologyBudgetSyncAdhoc(), model);
        BackgroundJobPayloadForBillingOntologyBudgetSyncAdhoc.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForBillingOntologyBudgetSyncAdhoc>): BackgroundJobPayloadForBillingOntologyBudgetSyncAdhoc {
        if (!model) return null;
        return BackgroundJobPayloadForBillingOntologyBudgetSyncAdhoc.newInstance(<BackgroundJobPayloadForBillingOntologyBudgetSyncAdhoc> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForBillingOntologyBudgetSyncAdhoc) {
        if (!obj) return;

        models.BackgroundJobPayloadForBillingOntologyBudgetSyncAdhoc.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForBillingOntologyBudgetSyncAdhoc): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForBillingOntologyBudgetSyncAdhoc.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
